/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var DataService = /** @class */ (function () {
            function DataService(injectedBreeze, $q) {
                this._logType = "DataService";
                this.serviceName = "breeze/Breeze";
                this.breezeModule = injectedBreeze;
                this.breezeModule.config.initializeAdapterInstance("modelLibrary", "backingStore", true); // backingStore is the modelLibrary for Angular
                this.entityManager = warsBreeze.entityManager; // gets metadata from the service
                this.$q = $q;
            }
            DataService.prototype.GetEntityType = function () {
                return null;
            };
            DataService.prototype.createNewEntity = function (entityName, config) {
                var configObject = config ? config : {};
                configObject["id"] = services.UtilityService.generateGuidComb();
                return warsBreeze.entityManager.createEntity(entityName, configObject);
            };
            DataService.prototype.createNewDetachedEntity = function (entityName) {
                return warsBreeze.entityManager.createEntity(entityName, {}, breeze.EntityState.Detached);
            };
            DataService.prototype.loadMetaData = function () {
                warsBreeze.entityManager.metadataStore.fetchMetadata(this.serviceName);
            };
            DataService.prototype.fMetaData = function () {
                return warsBreeze.entityManager.metadataStore.fetchMetadata(this.serviceName);
            };
            // return an array of entities that have changes
            DataService.prototype.getChanges = function (entityType) {
                return warsBreeze.entityManager.getChanges(entityType);
            };
            // subscribe to the entityChanged event
            DataService.prototype.subscribeChanges = function (callback) {
                warsBreeze.entityManager.entityChanged.subscribe(callback);
            };
            DataService.prototype.subscribeHasChanges = function (callback) {
                warsBreeze.entityManager.hasChangesChanged.subscribe(callback);
            };
            DataService.prototype.rejectChanges = function (entity) {
                if (entity === undefined) {
                    warsBreeze.entityManager.rejectChanges();
                }
                else if (entity !== null) {
                    entity.entityAspect.rejectChanges();
                }
            };
            DataService.prototype.resolveDeletesAndUpdatesPerformedOutsideOfBreeze = function (deleteResult) {
                if (deleteResult.wasSuccessful) {
                    var _loop_1 = function () {
                        var deleteEntry = deleteResult.deletedOrUpdatedEntities[index];
                        var cachedEntities = warsBreeze.entityManager.getEntities(deleteEntry.entityName);
                        var deletedCachedEntities = Enumerable.from(cachedEntities)
                            .where(function (i) { return deleteEntry.entityIds.indexOf(i.id) !== -1; })
                            .toArray();
                        deletedCachedEntities.forEach(function (entity) { return warsBreeze.entityManager.detachEntity(entity); });
                    };
                    for (var index = 0; index < deleteResult.deletedOrUpdatedEntities.length; index++) {
                        _loop_1();
                    }
                }
            };
            DataService.prototype.resolveDeletesPerformedOutsideOfBreeze = function (combinedDeleteResult) {
                if (combinedDeleteResult.wasSuccessful) {
                    var _loop_2 = function () {
                        var deleteEntry = combinedDeleteResult.deletedEntities[index];
                        var cachedEntities = warsBreeze.entityManager.getEntities(deleteEntry.entityName);
                        var deletedCachedEntities = Enumerable.from(cachedEntities)
                            .where(function (i) { return deleteEntry.entityIds.indexOf(i.id) !== -1; })
                            .toArray();
                        deletedCachedEntities.forEach(function (entity) { return warsBreeze.entityManager.detachEntity(entity); });
                    };
                    for (var index = 0; index < combinedDeleteResult.deletedEntities.length; index++) {
                        _loop_2();
                    }
                }
            };
            DataService.prototype.clearCachedEntities = function (entityName) {
                var cachedEntities = warsBreeze.entityManager.getEntities(entityName);
                cachedEntities.forEach(function (entity) { warsBreeze.entityManager.detachEntity(entity); });
            };
            DataService.prototype.clearCache = function () {
                warsBreeze.entityManager.clear();
            };
            DataService.prototype.hasChanges = function () {
                return warsBreeze.entityManager.hasChanges();
            };
            DataService.prototype.deleteEntitiesWithDeleteServiceWithoutWarning = function (deleteService) {
                var _this = this;
                var defer = this.$q.defer();
                var deletedEntities = this.getPersistedEntitiesMarkedForDeletion();
                var deleteInfo = {
                    entitiesToDelete: []
                };
                for (var i = 0; i < deletedEntities.length; i++) {
                    var entity = deletedEntities[i];
                    var keyString = entity.entityAspect.getKey().toString();
                    var keyBeginIndex = keyString.indexOf("-");
                    var key = keyString.substr(keyBeginIndex + 1);
                    deleteInfo.entitiesToDelete.push({ name: entity.entityType.shortName, id: key });
                }
                deleteService.deleteBatchRecursivelyWithoutWarning(deleteInfo, true).then(function (combinedDeleteResult) {
                    _this.resolveDeletesPerformedOutsideOfBreeze(combinedDeleteResult);
                    defer.resolve(true);
                });
                return defer.promise;
            };
            DataService.prototype.getPersistedEntitiesMarkedForDeletion = function () {
                var itemsMarkedForDeletion = [];
                var changes = warsBreeze.entityManager.getChanges();
                for (var i = 0; i < changes.length; i++) {
                    if (changes[i].entityAspect.entityState.isDeleted()) {
                        itemsMarkedForDeletion.push(changes[i]);
                    }
                }
                return itemsMarkedForDeletion;
            };
            DataService.prototype.saveChanges = function (entities, successCallback, failCallback) {
                var _this = this;
                if (warsBreeze.entityManager.hasChanges()) {
                    if (DataService.isSaving) {
                        setTimeout(function () { return _this.saveChanges(entities, successCallback, failCallback); }, 50);
                        return;
                    }
                    DataService.isSaving = true;
                    warsBreeze.entityManager.saveChanges(entities).then(function (successfulSaveResult) {
                        DataService.isSaving = false;
                        if (successCallback) {
                            successCallback(successfulSaveResult.entities);
                        }
                    }, function (failureReason) {
                        DataService.isSaving = false;
                        services.WarsLogger.logError("Breeze Save Changes Failed: " + failureReason, _this._logType);
                        if (failCallback) {
                            failCallback(failureReason);
                        }
                    });
                }
            };
            DataService.prototype.saveAllChanges = function (successCallback, failCallback, saveOptions) {
                var _this = this;
                if (warsBreeze.entityManager.hasChanges()) {
                    if (DataService.isSaving) {
                        setTimeout(function () { return _this.saveAllChanges(successCallback, failCallback, saveOptions); }, 50);
                        return;
                    }
                    DataService.isSaving = true;
                    warsBreeze.entityManager.saveChanges(null, saveOptions).then(function (successfulSaveResult) {
                        DataService.isSaving = false;
                        if (successCallback) {
                            successCallback(successfulSaveResult.entities);
                        }
                    }, function (failureReason) {
                        DataService.isSaving = false;
                        services.WarsLogger.logError("Breeze Save All Changes Failed: " + failureReason, _this._logType);
                        if (failCallback) {
                            failCallback(failureReason);
                        }
                        else {
                            console.error(failureReason);
                        }
                    });
                }
                else {
                    if (successCallback) {
                        successCallback([]);
                    }
                }
            };
            DataService.prototype.executeQuery = function (query) {
                var _this = this;
                var d = this.$q.defer();
                warsBreeze.entityManager.executeQuery(query)
                    .then(function (queryResult) { d.resolve(queryResult.results); }, function (reason) {
                    services.WarsLogger.logError("Breeze Query Rejected: " + reason, _this._logType);
                    d.reject(reason);
                })
                    .catch(function (e) {
                    console.error(e);
                });
                return d.promise;
            };
            DataService.prototype.fetch = function (query) {
                var _this = this;
                var d = this.$q.defer();
                warsBreeze.entityManager.executeQuery(query)
                    .then(function (queryResult) { d.resolve(queryResult.results[0]); }, function (reason) {
                    services.WarsLogger.logError("Breeze Fetch Rejected: " + reason, _this._logType);
                    d.reject(reason);
                })
                    .catch(function (e) {
                    console.error(e);
                });
                return d.promise;
            };
            DataService.prototype.fetchById = function (id, entityName) {
                var d = this.$q.defer();
                warsBreeze.entityManager.fetchEntityByKey(entityName, id, true).then(function (r) {
                    d.resolve(r.entity);
                });
                return d.promise;
            };
            DataService.prototype.handlerResponded = function (response, params) {
                response.data.requestParams = params;
                return response.data;
            };
            DataService.isSaving = false;
            return DataService;
        }());
        services.DataService = DataService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('DataService', ['breeze', '$q']);
